import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import { getAxiosCancelToken } from "../../../utils/getAxiosCancelToken";
import apiRequestType from "../../apiRequestType";

let cancelToken;
const getUserReport = (
  categoryId,
  cityId,
  classId,
  countryId,
  fromDate,
  pageNumber = 1,
  pageSize = 20,
  stateId,
  toDate,
  workOfficeId,
  trainingType,
  userId,
  userGroupId
) => {
  cancelToken = getAxiosCancelToken(cancelToken);
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.TABULAR_REPORT.GET_USER_REPORT(
      categoryId,
      cityId,
      classId,
      countryId,
      fromDate,
      (pageNumber = 1),
      (pageSize = 20),
      stateId,
      toDate,
      workOfficeId,
      trainingType,
      userId,
      userGroupId
    ),
    "",
    cancelToken
  );
};

export default getUserReport;
